import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit  } from '@angular/core';
import { RevenueService } from './revenue.service';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { MultilanguageService } from '../../shared/services/multilanguage.service';
import { FieldConfig } from '../../shared/dynamicform/models/field-config.interface';
import { DynamicFormComponent } from '../../shared/dynamicform/dynamic-form/dynamic-form.component';
import { Validators } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatHint } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { JsonPipe } from '@angular/common';


@Component({
    selector: 'app-revenue-chart',
    templateUrl: './revenue.component.html',
    styleUrls: ['./revenue.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [DynamicFormComponent, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatHint, JsonPipe]
})
export class RevenueChartComponent implements OnInit, AfterViewInit  {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  public RevenueResult: any;
  constructor(private _rs: RevenueService, private _ml: MultilanguageService) {
  }

  config: FieldConfig[] = [
    {
      type: 'input',
      label: 'Full name',
      name: 'name',
      placeholder: 'Enter your name',
      validation: [ Validators.compose([ Validators.minLength(6), Validators.required ])],
      class: 'test'
    },
    {
      type: 'input',
      label: 'Full name',
      name: 'name',
      placeholder: 'Enter your name',
      validation: [ Validators.compose([ Validators.minLength(6), Validators.required ])],
      class: 'test'
    },
    {
      type: 'select',
      label: 'Favourite Food',
      name: 'food',
      options: ['Pizza', 'Hot Dogs', 'Knakworstje', 'Coffee'],
      placeholder: 'Select an option',
      validation: [Validators.required],
      class: ''
    },
    {
      label: 'Submit',
      name: 'submit',
      type: 'button'
    }
  ];

  async getRevenue() {
    this._rs.getRevenueRecord()
      .subscribe(result => {
        return this.RevenueResult = result;
      },
        err => console.error(err));
  }

  ngOnInit() {
    this.getRevenue();
  }
  ngAfterViewInit() {
    let previousValid = this.form.valid;
    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      }
    });

    this.form.setDisabled('submit', true);
    this.form.setValue('name', 'Todd Motto');
  }

  submit(value: {[name: string]: any}) {
    console.log(value);
  }

}
